module.exports = __webpack_public_path__ + "img/B1.9ace6e48.jpg";